import { render, staticRenderFns } from "./VideoGrid.vue?vue&type=template&id=53bfe117&scoped=true"
import script from "./VideoGrid.vue?vue&type=script&lang=js"
export * from "./VideoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bfe117",
  null
  
)

export default component.exports